export default "__VITE_ASSET__DilVbn$6__"